import $ from 'wee-dom';

export default (data) => {
    const phone = data.phone.length ? `<a href="${data.phone.attr('href')}" class="infobox__phone">${data.phone.text()}</a><br>` : '';

    return `<div class="infobox">
    <div class="infobox__title">${data.title}</div>
    <address class="address infobox__address">${data.address}</address>
    ${phone}
    <a href="${data.directions}" target="_blank" class="infobox__link">Get Directions</a>
    <a href="${data.url}" class="infobox__link">Learn more</a>
    </div>`
}